import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useExport } from "@/hooks/importToolXSLX";

const ExportButton = ({ model, params, label = null, ...props }) => {
  const { t } = useTranslation();
  const { loading, handleExport } = useExport();

  return (
    <Button
      key="export"
      onClick={() => handleExport(model, params)}
      loading={loading}
      icon={<DownloadOutlined />}
      {...props}
    >
      {label ?? t("global:export")}
    </Button>
  );
};

export default ExportButton;
